<template>
  <div class="Certificat-authority-main" :class="{ 'Certificat-authority-main-mobile': isMobile}">
    <Base-title title="权威认证 值得信赖 "></Base-title>
    <CertificatType></CertificatType>
  </div>
</template>
<script>
  export default {
    // 权威认证
    name: 'CertificatAuthority'
  };
</script>
<style lang="scss" scoped>
  .Certificat-authority-main {
    display: flex;
    align-items: center;
    padding-top: 0.91rem;
    width: 100%;
    height: 7.56rem;
    flex-direction: column;
    background: rgb(247 248 252 / 100%);
  }
  .Certificat-authority-main-mobile {
    padding-top: 2.1rem;
    height: 18.79rem;
  }
</style>
